import React, { useEffect, useState, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { Button, Form, Row, Col, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Spinner from '../../../shared/spinner';

import { OperadorDTO } from '../../../shared/dto/operadorDTO';
import { GerenteDTO } from '../../../shared/dto/gerenteDTO';
import { MatrizDTO } from '../../../shared/dto/matrizDTO';
import { PromotoraDTO } from '../../../shared/dto/promotoraDTO';

import { ButtonInativar, ButtonAtivar, ButtonAlterar } from '../../../shared/buttons';

import OperadorService from '../../../services/operadorService';
import SupervisorService from '../../../services/supervisorService';
import MatrizService from '../../../services/matrizService';
import PromotoraService from '../../../services/promotoraService';
import ImportacaoService from '../../../services/importacaoService'; // <--- Importado

import ConfirmModal from '../../../shared/customAlertConfirm';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import { useSlug } from '../../hooks/UseSlug';

//Paginação
import ResponsivePagination from 'react-responsive-pagination';

//Filtros e Ícones
import { faFilter, faRefresh, faFileImport, faDownload, faTimes } from '@fortawesome/free-solid-svg-icons'; // <--- Novos ícones
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProtectedActionInterno } from '../../../AccessControl';
import { ProtectedAction } from '../../../AccessControl';

function OperadorComponent() {
  useVerificaPermissao();
  const navigate = useNavigate();
  const slug = useSlug();

  // Services
  const operadorService: OperadorService = new OperadorService();
  const supervisorService = new SupervisorService();
  const matrizService = new MatrizService();
  const promotoraService = new PromotoraService();
  const importacaoService = new ImportacaoService(); // <--- Instância

  // States Principais
  const [loading, setLoading] = useState(true);
  const [operador, setOperador] = useState<OperadorDTO[]>([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState<{ id: any, ativo: boolean } | null>(null);

  // Paginação
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);

  // Controle de Painéis
  const [filtros, setFiltros] = useState(false);
  const [importacaoOpen, setImportacaoOpen] = useState(false); // <--- State Painel Importação

  // Filtros States
  const [matrizFiltro, setMatrizFiltro] = useState('');
  const [promotoraFiltro, setPromotoraFiltro] = useState('');
  const [supervisorFiltro, setSupervisorFiltro] = useState('');
  const [codigoFiltro, setCodigoFiltro] = useState('');
  const [nomeFiltro, setNomeFiltro] = useState('');
  const [cidadeFiltro, setCidadeFiltro] = useState('');
  const [statusOrigemFiltro, setStatusOrigemFiltro] = useState('');
  const [cpfFiltro, setCpfFiltro] = useState('');

  const [matrizes, setMatrizes] = useState<MatrizDTO[]>([]);
  const [promotoras, setPromotoras] = useState<PromotoraDTO[]>([]);
  const [supervisores, setSupervisores] = useState<GerenteDTO[]>([]);

  // States de Importação
  const [fileToUpload, setFileToUpload] = useState<File | null>(null);
  const [importLoading, setImportLoading] = useState(false);
  const [importMessage, setImportMessage] = useState<{ type: 'success' | 'danger', text: string } | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  // --- Toggle Painéis ---
  const toggleFiltros = () => {
    setFiltros(!filtros);
    setImportacaoOpen(false); // Fecha importação ao abrir filtros
  };

  const toggleImportacao = () => {
    setImportacaoOpen(!importacaoOpen);
    setFiltros(false); // Fecha filtros ao abrir importação
    setImportMessage(null);
  };

  // --- Listagem ---
  const listarTodosOperadores = async (page = 1) => {
    try {
      setLoading(true);

      const filtros = {
        matriz: matrizFiltro || null,
        promotora: promotoraFiltro || null,
        supervisor: supervisorFiltro || null,
        codigo: codigoFiltro || null,
        nome: nomeFiltro || null,
        cidade: cidadeFiltro || null,
        statusOrigem: statusOrigemFiltro !== '' ? statusOrigemFiltro : null,
        cpf: cpfFiltro || null
      };

      const responseList = await operadorService.listarTodosOperadores(page - 1, 10, filtros);
      const jsonPage = responseList.data;

      setOperador(jsonPage.content);
      setTotalPaginas(jsonPage.totalPages);
      setPaginaAtual(page);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const ativarInativarOperador = async (id: any, ativo: boolean) => {
    setCurrentAction({ id, ativo });
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    if (currentAction) {
      const { id, ativo } = currentAction;
      try {
        await operadorService.ativarInativarOperador(id);
        listarTodosOperadores();
      } catch (err) {
        console.error(err);
      } finally {
        setConfirmOpen(false);
        setCurrentAction(null);
      }
    }
  };

  const onPageChange = (page: number) => {
    setPaginaAtual(page);
    listarTodosOperadores(page);
  };

  const getBadgeClass = (situacao: string | null | undefined) => {
    if (!situacao) return 'bg-secondary';
    switch (situacao.toUpperCase()) {
      case 'VALIDO':
      case 'SUCESSO':
        return 'bg-success';
      case 'INVALIDO':
      case 'EXPIRADO':
      case 'ERRO':
        return 'bg-danger';
      case 'NAO_ENCONTRADO':
        return 'bg-warning text-dark';
      default:
        return 'bg-secondary';
    }
  };

  function formatarCPF(valor: string): string {
    valor = valor.replace(/\D/g, '');
    valor = valor.replace(/^(\d{3})(\d)/, '$1.$2');
    valor = valor.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3');
    valor = valor.replace(/\.(\d{3})(\d)/, '.$1-$2');
    return valor.slice(0, 14);
  }

  // --- LÓGICA DE IMPORTAÇÃO ---
  const handleDownloadModelo = async () => {
    try {
      // Endpoint espera 'OPERADOR'
      const response = await importacaoService.baixarModelo('OPERADOR');

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'modelo_importacao_operador.xlsx');
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.error("Erro ao baixar modelo", error);
      setImportMessage({ type: 'danger', text: 'Erro ao baixar o modelo.' });
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setImportMessage(null);
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const extension = file.name.split('.').pop()?.toLowerCase();

      if (extension !== 'xlsx' && extension !== 'csv') {
        setImportMessage({ type: 'danger', text: 'Formato inválido. Apenas .xlsx e .csv são permitidos.' });
        setFileToUpload(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      setFileToUpload(file);
    }
  };

  const handleImportar = async () => {
    if (!fileToUpload) {
      setImportMessage({ type: 'danger', text: 'Selecione um arquivo para importar.' });
      return;
    }

    try {
      setImportLoading(true);
      // Chama o endpoint de importação 'OPERADOR'
      await importacaoService.importar('OPERADOR', fileToUpload);

      setImportMessage({ type: 'success', text: 'Importação realizada com sucesso!' });
      setFileToUpload(null);
      if (fileInputRef.current) fileInputRef.current.value = "";

      // Recarrega lista
      listarTodosOperadores(1);

      // Fecha painel após sucesso
      setTimeout(() => {
        setImportacaoOpen(false);
        setImportMessage(null);
      }, 3000);

    } catch (error: any) {
      console.error("Erro na importação", error);
      const msg = error.response?.data || 'Erro ao processar importação.';
      setImportMessage({ type: 'danger', text: msg });
    } finally {
      setImportLoading(false);
    }
  };

  // --- Efeitos ---
  useEffect(() => {
    listarTodosOperadores(paginaAtual);
  }, [paginaAtual]);

  useEffect(() => {
    const carregarMatrizes = async () => {
      try {
        const response = await matrizService.listarTodasMatrizesAtivas();
        setMatrizes(response.data || []);
      } catch (error) {
        console.error("Erro ao carregar matrizes:", error);
      }
    };
    carregarMatrizes();
  }, []);

  useEffect(() => {
    const carregarPromotorasPorMatriz = async () => {
      if (matrizFiltro) {
        try {
          const filtros = { matriz: matrizFiltro };
          const response = await promotoraService.listarTodasPromotoras(0, 9999999, filtros);
          const data = response.data;
          setPromotoras(Array.isArray(data.content) ? data.content : []);
        } catch (error) {
          console.error("Erro ao carregar promotoras:", error);
          setPromotoras([]);
        }
      } else {
        setPromotoras([]);
        setPromotoraFiltro("");
      }
    };
    carregarPromotorasPorMatriz();
  }, [matrizFiltro]);

  useEffect(() => {
    const carregarSupervisoresPorPromotora = async () => {
      if (promotoraFiltro) {
        try {
          const filtros = { promotora: promotoraFiltro };
          const response = await supervisorService.listarTodosGerentes(0, 9999999, filtros);
          const data = response.data;
          setSupervisores(Array.isArray(data.content) ? data.content : []);
        } catch (error) {
          console.error("Erro ao carregar supervisores:", error);
          setSupervisores([]);
        }
      } else {
        setSupervisores([]);
        setSupervisorFiltro("");
      }
    };
    carregarSupervisoresPorPromotora();
  }, [promotoraFiltro]);

  return (
    <>
      <div className="position-relative m-md-3">
        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h5>Origens &gt; Operador</h5>
          <div style={{ display: 'flex', gap: '10px' }}>
            {/* Botão Filtros */}
            <Button id="App-button-cor-principal-escura" onClick={toggleFiltros} active={filtros}>
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
              Filtros
            </Button>

            {/* Botão Importar */}
            <ProtectedActionInterno>
              <Button variant="outline-primary" onClick={toggleImportacao} active={importacaoOpen}>
                <FontAwesomeIcon icon={faFileImport} style={{ marginRight: '10px' }} />
                Importar
              </Button>
            </ProtectedActionInterno>

            <Button
              onClick={() => navigate(`${slug ? `/${slug}` : ''}/origens-operador/inclusao`, { state: { id: null } })}
              id="App-button-cor-principal-escura"
            >
              + Novo Operador
            </Button>
          </div>
        </div>

        {/* --- ÁREA DE IMPORTAÇÃO --- */}
        {importacaoOpen && (
          <div className="card card-body mb-4" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
            <h6 className="card-title mb-3">
              <FontAwesomeIcon icon={faFileImport} className="me-2" />
              Importação em Lote
            </h6>
            <Row className="align-items-end g-3">
              <Col md={3}>
                <Form.Label>Passo 1: Modelo</Form.Label>
                <Button variant="outline-secondary" className="w-100" onClick={handleDownloadModelo}>
                  <FontAwesomeIcon icon={faDownload} className="me-2" />
                  Baixar Modelo
                </Button>
              </Col>

              <Col md={5}>
                <Form.Group controlId="formFile">
                  <Form.Label>Passo 2: Selecione o Arquivo (.xlsx)</Form.Label>
                  <Form.Control
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept=".xlsx, .csv"
                  />
                </Form.Group>
              </Col>

              <Col md={4} className="d-flex gap-2">
                <Button
                  id="App-button-cor-principal-escura"
                  className="flex-grow-1"
                  onClick={handleImportar}
                  disabled={!fileToUpload || importLoading}
                >
                  {importLoading ? <Spinner loading={true} /> : 'Confirmar Importação'}
                </Button>
                <Button variant="secondary" onClick={() => {
                  setImportacaoOpen(false);
                  setImportMessage(null);
                  setFileToUpload(null);
                }}>
                  <FontAwesomeIcon icon={faTimes} />
                </Button>
              </Col>
            </Row>

            {importMessage && (
              <Alert variant={importMessage.type} className="mt-3 mb-0">
                {importMessage.text}
              </Alert>
            )}
          </div>
        )}

        {/* --- ÁREA DE FILTROS --- */}
        {filtros ?
          <>
            <Row className="mb-4" style={{ marginTop: '15px' }}>
              <Form.Group as={Col} md='2' controlId="formSelectMatriz">
                <Form.Label>Matriz</Form.Label>
                <Form.Select value={matrizFiltro} onChange={(e) => setMatrizFiltro(e.target.value)}>
                  <option value="">Selecione</option>
                  {matrizes.map((matriz) => (
                    <option key={matriz.id} value={String(matriz.id)}>
                      {matriz.id} - {matriz.nome}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group as={Col} md='2' controlId="formSelectPromotora">
                <Form.Label>Promotora</Form.Label>
                <Form.Select value={promotoraFiltro} onChange={(e) => setPromotoraFiltro(e.target.value)}>
                  <option value="">Selecione</option>
                  {promotoras.map((promotora) => (
                    <option key={promotora.id} value={String(promotora.id)}>
                      {promotora.id} - {promotora.nome}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group as={Col} md='2' controlId="formSelectSupervisores">
                <Form.Label>Supervisor</Form.Label>
                <Form.Select value={supervisorFiltro} onChange={(e) => setSupervisorFiltro(e.target.value)}>
                  <option value="">Selecione</option>
                  {supervisores.map((supervisor) => (
                    <option key={supervisor.id} value={String(supervisor.id)}>
                      {supervisor.id} - {supervisor.nome}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group as={Col} md='2' controlId="formBasicSelect">
                <Form.Label>Código </Form.Label>
                <input type="text" className="form-control" value={codigoFiltro} onChange={(e) => setCodigoFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formBasicSelect">
                <Form.Label>Nome</Form.Label>
                <input type="text" className="form-control" value={nomeFiltro} onChange={(e) => setNomeFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formBasicSelect">
                <Form.Label>Cidade</Form.Label>
                <input type="text" className="form-control" value={cidadeFiltro} onChange={(e) => setCidadeFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formSelectStatusOrigem">
                <Form.Label>Status Origem</Form.Label>
                <Form.Select
                  value={statusOrigemFiltro}
                  onChange={(e) => setStatusOrigemFiltro(e.target.value)}
                >
                  <option value="">Todas</option>
                  <option value="true">Ativas</option>
                  <option value="false">Inativas</option>
                </Form.Select>
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formBasicSelect">
                <Form.Label>CPF</Form.Label>
                <input
                  type="text"
                  className="form-control"
                  value={cpfFiltro}
                  onChange={(e) => setCpfFiltro(formatarCPF(e.target.value))}
                  maxLength={14}
                />
              </Form.Group>
            </Row>
            <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <Button id="App-button-cor-principal-escura" onClick={() => listarTodosOperadores(1)}>
                <FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
                Aplicar
              </Button>
              <Button variant="secondary" onClick={() => {
                setMatrizFiltro(''); setPromotoraFiltro(''); setSupervisorFiltro('');
                setCodigoFiltro(''); setNomeFiltro(''); setCidadeFiltro('');
                setStatusOrigemFiltro(''); setCpfFiltro('');
                listarTodosOperadores(1);
              }}>
                <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '5px' }} />
                Limpar
              </Button>
            </div>
          </>
          : null}

        {loading ? <Spinner loading={loading} /> : (
          <div className="table-responsive">
            <div>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th scope="col" id="App-header-table">Operador</th>
                    <th scope="col" id="App-header-table">CPF</th>
                    <th scope="col" id="App-header-table">Cidade</th>
                    <th scope="col" id="App-header-table">Telefone</th>
                    <th scope="col" id="App-header-table">E-mail</th>
                    <th scope="col" id="App-header-table">Cód. Supervisor</th>
                    <th scope="col" id="App-header-table">Supervisor</th>
                    <th scope="col" id="App-header-table">Ponto de Venda</th>
                    <th scope="col" id="App-header-table">Status<br />Do Certificado</th>
                    <ProtectedAction>
                      <th scope="col" id="App-header-table">Alteração</th>
                      <th scope="col" id="App-header-table">Status</th>
                    </ProtectedAction>
                  </tr>
                </thead>
                <tbody>
                  {operador.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id} - {item.nome}</td>
                      <td>{item.cpf}</td>
                      <td>{item.cidade}</td>
                      <td>{item.telefoneComercial}</td>
                      <td>{item.email}</td>
                      <td>{item.gerente}</td>
                      <td>{item.nomeGerente}</td>
                      <td>
                        {(item.pontoVenda && item.nomePontoVenda)
                          ? `${item.pontoVenda} - ${item.nomePontoVenda}`
                          : '-'
                        }
                      </td>
                      <td>
                        {item.situacaoCertificado ? (
                          <span className={`badge ${
                            item.situacaoCertificado.toLowerCase() === 'obtendo informações...' ? 'bg-primary' :
                            item.situacaoCertificado.toLowerCase() === 'erro' ? 'bg-danger' :
                            item.situacaoCertificado.toLowerCase() === 'não cadastrado' ? 'bg-danger' :
                            item.situacaoCertificado.toLowerCase() === 'nao cadastrado' ? 'bg-danger' :
                            item.situacaoCertificado.toLowerCase() === 'não localizado' ? 'bg-danger' :
                            item.situacaoCertificado.toLowerCase() === 'nao localizado' ? 'bg-danger' :
                            item.situacaoCertificado.toLowerCase() === 'dentro do prazo' ? 'bg-success' :
                            item.situacaoCertificado.toLowerCase() === 'fora do prazo' ? 'bg-warning text-dark' :
                            item.situacaoCertificado.toLowerCase() === 'divergente' ? 'bg-danger' :
                            item.situacaoCertificado.toLowerCase() === 'consiste' ? 'bg-success' :
                            'bg-secondary'
                          }`}>
                            {item.situacaoCertificado}
                          </span>
                        ) : (
                          <span className="badge bg-secondary">Sem Certificado</span>
                        )}
                      </td>
                      <ProtectedAction>
                        <td>
                          <Link to={`/origens-operador/alteracao`} state={{ id: item.id }}>
                            <ButtonAlterar />
                          </Link>
                        </td>
                        <td>
                          {item.ativo ?
                            <ButtonInativar onClick={() => ativarInativarOperador(item.id, item.ativo)} />
                            :
                            <ButtonAtivar onClick={() => ativarInativarOperador(item.id, item.ativo)} />
                          }
                        </td>
                      </ProtectedAction>
                    </tr>
                  ))}
                </tbody>
              </table>
              <ResponsivePagination
                current={paginaAtual}
                total={totalPaginas}
                onPageChange={onPageChange}
              />
              {confirmOpen && (<ConfirmModal message={currentAction?.ativo ? 'Tem certeza que deseja inativar este item?' : 'Tem certeza que deseja ativar este item?'} onConfirm={handleConfirm} onCancel={() => { setConfirmOpen(false); setCurrentAction(null) }} />)}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default OperadorComponent;
